import { theme } from '@theme';
import styled from 'styled-components';
import { RenderPosition } from '../../enums/RenderPosition';

type DropdownOptionProps = {
  maxHeight?: number;
  left?: number;
  top?: number;
};

export const DropdownOption = styled.div.attrs<DropdownOptionsProps>({
  'data-testid': 'dropdown-option',
})<DropdownOptionsProps>`
  position: absolute;
  z-index: 95;
  background-color: white;
  border-radius: 3px;
  width: 100%;
  box-shadow: 0px 2px 5px 3px rgba(0, 0, 0, 0.2);
  ${(props) =>
    props.dynamicRender
      ? props.renderPosition === RenderPosition.Top && `bottom: ${props.filterHeight}px`
      : ``};
  ${(props) =>
    props.dynamicRender
      ? props.renderPosition === RenderPosition.Bottom && `top: ${props.filterHeight}px`
      : ``};
  ${(props) => (props.left ? `left: ` + props.left + `px;` : `left: 0px;`)}
  ${(props) => props.searchable && `border-top-left-radius: 3px; border-top-right-radius: 3px;`}
  ${(props) => props.top && `top: ` + props.top + `px;`}

  & .options {
    overflow: auto;
    max-height: ${(props) => (props.maxHeight ? props.maxHeight + `px` : `auto`)};

    ::-webkit-scrollbar {
      width: 6px;
    }

    ::-webkit-scrollbar-track {
      -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
      border-radius: 8px;
    }

    ::-webkit-scrollbar-thumb {
      background-color: ${theme.palette.darkGray};
      border-radius: 8px;
    }

    & > div:nth-child(odd) {
      ${(props) => props.striped && `background-color: ${theme.palette.gray}`};
    }
  }

  &.react-table-header-range {
    position: absolute;
    width: 210px;
    top: 42px;
  }
`;

type DropdownOptionsProps = DropdownOptionProps & {
  striped?: boolean;
  searchable?: boolean;
  renderPosition?: RenderPosition;
  filterHeight?: number;
  dynamicRender?: boolean;
  isBulkOperation?: boolean;
};

export const DropdownOptions = styled(DropdownOption).attrs<DropdownOptionsProps>({
  'data-testid': 'dropdown-options',
})<DropdownOptionsProps>`
  & div.form-check:hover {
    background-color: ${() => theme.palette.darkGray}!important;
    color: white !important;
  }
  & div.form-check:hover span:not(.exclude-hover) {
    color: white;
  }

  &.label-type {
    display: block;
    position: relative;
    box-shadow: none;
  }
`;

export const DropdownNavigationOptions = styled(DropdownOption).attrs<DropdownOptionsProps>({
  'data-testid': 'dropdown-options',
})<DropdownOptionsProps>`
  &:before {
    content: '';
    display: block;
  }

  &:after {
    content: '';
    display: table;
    clear: both;
  }
`;

export const PortfolioDropdownOptions = styled(DropdownOption).attrs<DropdownOptionsProps>({
  'data-testid': 'portfolio-dropdown-options',
})<DropdownOptionsProps>`
  width: 210px;
  margin-left: ${(props) => (props.isBulkOperation ? '308' : '50')}px;
  margin-top: 63px;
  & > div:hover {
    background-color: ${() => theme.palette.white}!important;
  }
`;
